import { render, staticRenderFns } from "./_ProductsPage.vue?vue&type=template&id=6171a9c6&"
import script from "./_ProductsPage.vue?vue&type=script&lang=ts&"
export * from "./_ProductsPage.vue?vue&type=script&lang=ts&"
import style0 from "./_ProductsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports